import { useContext } from 'react';
import { FormControlLabel, Grid, Checkbox, TextField, MenuItem } from '@material-ui/core';
import { applicationContext } from 'helpers/services';
import { IBulkEditRequest } from '../BulkEditContext';


interface IProps {
    request: IBulkEditRequest
    updateRequest: (newRequest: IBulkEditRequest) => void
}

let TicketStatus = ({ request, updateRequest }: IProps) => {
    let { ticketStatuses } = useContext(applicationContext);


    return (
        <>
            <Grid item xs={4}>
                <FormControlLabel
                    checked={request.changeStatus}
                    control={<Checkbox />}
                    label="Status"
                    onChange={(e, value) => {
                        updateRequest({
                            ...request,
                            changeStatus: value
                        })
                    }}
                />
            </Grid>

            {request.changeStatus &&
                <Grid item xs>
                    <TextField
                        label="Ticket status"
                        fullWidth
                        select
                        variant="outlined"
                        value={request.status}
                        onChange={(e) => {
                            updateRequest({
                                ...request,
                                status: e.target.value || ""
                            })
                        }}
                    >
                        {ticketStatuses.map(status =>
                            <MenuItem key={status.id} value={status.id}>
                                {status.name}
                            </MenuItem>
                        )}
                    </TextField>
                </Grid>
            }
        </>
    )
}

export default TicketStatus;